import React, { useEffect, useRef } from 'react';
import './SpeechBubble.css';

const SpeechBubble = ({ message, isVisible, onMouseEnter, onMouseLeave, catPosition, showHelpButton, setShowHelpButton }) => {
  const resetHelpButtonTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (resetHelpButtonTimeoutRef.current) {
        clearTimeout(resetHelpButtonTimeoutRef.current);
        resetHelpButtonTimeoutRef.current = null;
      }
    };
  }, []);

  if (!isVisible || !message) {
    return null;
  }

  // Проверяем, является ли сообщение ссылкой
  const isLink = message.startsWith('http');

  // НОВЫЙ КОД - обработчик клика по кнопке помощи (ЗАКОММЕНТИРОВАТЬ ПРИ ОТКАТЕ)
  const handleHelpButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowHelpButton(false);

    // Через 3 секунды снова показываем кнопку "Помощь"
    if (resetHelpButtonTimeoutRef.current) {
      clearTimeout(resetHelpButtonTimeoutRef.current);
    }
    resetHelpButtonTimeoutRef.current = setTimeout(() => {
      setShowHelpButton(true);
      resetHelpButtonTimeoutRef.current = null;
    }, 3000);
  };
  // КОНЕЦ НОВОГО КОДА - обработчик клика по кнопке помощи

  const handleClick = (e) => {
    if (isLink) {
      e.preventDefault();
      window.open(message, '_blank');
    }
  };

  const handleMouseEnter = (e) => {
    e.stopPropagation(); // Предотвращаем всплытие события
    e.preventDefault(); // Предотвращаем действие по умолчанию
    if (onMouseEnter) {
      onMouseEnter(e);
    }
  };

  const handleMouseLeave = (e) => {
    e.stopPropagation(); // Предотвращаем всплытие события
    e.preventDefault(); // Предотвращаем действие по умолчанию
    if (onMouseLeave) {
      onMouseLeave(e);
    }
  };

  const handleMouseMove = (e) => {
    e.stopPropagation(); // Предотвращаем всплытие события
    e.preventDefault(); // Предотвращаем действие по умолчанию
  };

  // Позиционируем пузырь относительно контейнера кошки (не через портал)
  return (
    <div 
      className="speech-bubble"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      <div className="speech-bubble-content">
        {/* НОВЫЙ КОД - логика отображения кнопки помощи (ЗАКОММЕНТИРОВАТЬ ПРИ ОТКАТЕ) */}
        {showHelpButton ? (
          <button 
            onClick={handleHelpButtonClick}
            className="speech-bubble-help-button"
          >
            ❓ Помощь
          </button>
        ) : (
          isLink ? (
            <a 
              href={message} 
              onClick={handleClick}
              className="speech-bubble-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              🔗 Помощь
            </a>
          ) : (
            <span className="speech-bubble-text">{message}</span>
          )
        )}
        {/* КОНЕЦ НОВОГО КОДА - логика отображения кнопки помощи */}
      </div>
      <div className="speech-bubble-tail"></div>
    </div>
  );
};

export default SpeechBubble;
